import React, { memo } from 'react'

import { SliderProps } from '@mui/material'

import { StyledSlider } from './index.styles'

const CustomSlider = (props: SliderProps) => {
  return (
    <StyledSlider
      track={false}
      valueLabelDisplay="off"
      // eslint-disable-next-line
      {...props}
    />
  )
}

export default memo(CustomSlider)
